import type {
  ModuleID,
  ModulesConfig,
  VersionString,
  ViewModuleRef,
} from "@bestowinc/tinkertoy-core";

import { extractSlotModuleRefs, getModuleVersion, resolveModuleProps } from "./resolve-module-refs";

/**
 * Lists every `(moduleId, version)` that will be rendered for this view, in
 * tree order, so callers can `Promise`-prime loads before the first
 * `ModuleRenderer` read (avoids a waterfall of Suspense).
 */
export function collectAllModuleLoadKeys(
  layoutRef: ViewModuleRef,
  contentRefs: Array<ViewModuleRef>,
  config: ModulesConfig,
  resolvedModuleVersions: Record<ModuleID, VersionString>,
): Array<{ moduleId: ModuleID; version: VersionString }> {
  const out: Array<{ moduleId: ModuleID; version: VersionString }> = [];

  function visit(ref: ViewModuleRef): void {
    out.push({
      moduleId: ref.moduleId,
      version: getModuleVersion(ref, resolvedModuleVersions),
    });
    const rawProps = resolveModuleProps(ref, config);
    const slotExtraction = extractSlotModuleRefs(rawProps);
    if (slotExtraction) {
      for (const slotRef of Object.values(slotExtraction.slotRefs)) {
        visit(slotRef);
      }
    }
  }

  visit(layoutRef);
  for (const c of contentRefs) {
    visit(c);
  }
  return out;
}
